import { connect } from 'react-redux';

import BillingForm from './BillingForm';
import { actionCreators } from '../../../dux/org';

const mapDispatchToProps = {
  onStripeSubmit: actionCreators.createStripeSource,
  onStripeSuccess: actionCreators.updateStripeSource,
};

export default connect(null, mapDispatchToProps)(BillingForm);
